__webpack_require__.hmrF = () => ("reader." + __webpack_require__.h() + ".hot-update.json");